/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getInviteCodes.defs.js'
export * as $defs from './getInviteCodes.defs.js'
